var _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnauthorizedImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 382.398,
    style: {
      fill: "#EBEBEB"
    },
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.779,
    y: 398.494,
    style: {
      fill: "#EBEBEB"
    },
    width: 33.122,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.527,
    y: 401.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 8.693,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.586,
    y: 389.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 19.192,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.459,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 43.193,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.556,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 6.333,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.471,
    y: 395.111,
    style: {
      fill: "#EBEBEB"
    },
    width: 93.676,
    height: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M237.014,337.8H43.915c-3.147,0-5.708-2.561-5.708-5.708V60.66c0-3.147,2.561-5.708,5.708-5.708 h193.099c3.146,0,5.707,2.561,5.707,5.708v271.432C242.721,335.239,240.16,337.8,237.014,337.8z M43.915,55.203 c-3.01,0-5.458,2.448-5.458,5.458v271.432c0,3.01,2.448,5.458,5.458,5.458h193.099c3.009,0,5.457-2.448,5.457-5.458V60.66 c0-3.009-2.448-5.458-5.457-5.458H43.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M453.31,337.8H260.212c-3.147,0-5.707-2.561-5.707-5.708V60.66c0-3.147,2.561-5.708,5.707-5.708 H453.31c3.148,0,5.708,2.561,5.708,5.708v271.432C459.019,335.239,456.458,337.8,453.31,337.8z M260.212,55.203 c-3.009,0-5.457,2.448-5.457,5.458v271.432c0,3.01,2.448,5.458,5.457,5.458H453.31c3.01,0,5.458-2.448,5.458-5.458V60.66 c0-3.009-2.448-5.458-5.458-5.458H260.212z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 101.286,
    y: 76.163,
    style: {
      fill: "#E6E6E6"
    },
    width: 291.786,
    height: 136.518
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.34,
    y: 76.163,
    style: {
      fill: "#F0F0F0"
    },
    width: 294.128,
    height: 136.518
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.286,
    y: 212.681,
    style: {
      fill: "#E6E6E6"
    },
    width: 291.786,
    height: 6.964
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.663,
    y: 212.681,
    style: {
      fill: "#F0F0F0"
    },
    width: 294.128,
    height: 6.964
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.299,
    y: 3.512,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 394.8258 -105.9816)",
    style: {
      fill: "#FAFAFA"
    },
    width: 124.21,
    height: 281.82
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "139.733,206.528 156.861,82.318 183.589,82.318 166.46,206.528  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M112.343,200.402c-0.243,0-0.44-0.197-0.44-0.44V86.321c0-0.243,0.197-0.44,0.44-0.44 c0.243,0,0.44,0.197,0.44,0.44v113.642C112.783,200.205,112.586,200.402,112.343,200.402z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "172.202,206.528 189.33,82.318 199.75,82.318 182.622,206.528  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.818,
    y: 144.031,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 535.345 -246.5007)",
    style: {
      fill: "#E6E6E6"
    },
    width: 124.21,
    height: 0.781
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#EBEBEB"
    },
    points: "398.923,91.596 107.137,91.596 106.571,84.709 398.357,84.709  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#EBEBEB"
    },
    points: "398.923,102.891 107.137,102.891 106.571,96.004 398.357,96.004  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#EBEBEB"
    },
    points: "398.923,114.186 107.137,114.186 106.571,107.299 398.357,107.299  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#EBEBEB"
    },
    points: "398.923,125.481 107.137,125.481 106.571,118.594 398.357,118.594  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#EBEBEB"
    },
    points: "398.923,136.776 107.137,136.776 106.571,129.889 398.357,129.889  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#EBEBEB"
    },
    points: "398.923,148.071 107.137,148.071 106.571,141.184 398.357,141.184  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 394.47,
    y: 247,
    style: {
      fill: "#E6E6E6"
    },
    width: 44.53,
    height: 135.399
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFA"
    },
    points: "427.109,382.399 439,382.399 439,363.708 414.642,363.708  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.056,
    y: 247,
    style: {
      fill: "#E6E6E6"
    },
    width: 44.53,
    height: 135.399
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.209,
    y: 247,
    style: {
      fill: "#FAFAFA"
    },
    width: 131.791,
    height: 128.966
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFA"
    },
    points: "319.099,382.399 307.209,382.399 307.209,363.708 331.567,363.708  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.433,
    y: 295.057,
    style: {
      fill: "#F0F0F0"
    },
    width: 113.343,
    height: 32.274
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.433,
    y: 334.229,
    style: {
      fill: "#F0F0F0"
    },
    width: 113.343,
    height: 32.274
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M407.292,298.508h-68.375c-2.582,0-4.674-2.093-4.674-4.674v-1.572h77.724v1.572 C411.966,296.415,409.873,298.508,407.292,298.508z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.433,
    y: 255.884,
    style: {
      fill: "#F0F0F0"
    },
    width: 113.343,
    height: 32.274
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M407.292,259.335h-68.375c-2.582,0-4.674-2.093-4.674-4.674v-1.572h77.724v1.572 C411.966,257.242,409.873,259.335,407.292,259.335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M407.292,337.68h-68.375c-2.582,0-4.674-2.093-4.674-4.674v-1.572h77.724v1.572 C411.966,335.587,409.873,337.68,407.292,337.68z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M53.417,275.867c2.481-7.122,22.043,2.563,29.981,14.366c5.287,7.86,8.517,16.25,10.025,27.521 c-0.181-12.86-0.386-26.677-0.587-39.716c-1.605-3.251-5.271-10.747-7.908-16.687c-8.798-19.818-29.718-27.198-36.945-39.711 c-9.47-16.395-9.415-40.989-1.354-49.864c7.006-7.712,30.205,44.436,32.818,50.262c8.988,20.039,11.601,34.911,13.285,49.318 c-0.192-12.247-0.375-23.491-0.526-32.167c-0.491-28.298-1.105-37.4-1.386-40.201c-0.969-1.368-2.112-2.962-2.777-3.817 c-5.614-7.228-18.071-15.832-24.296-26.339c-9.09-15.341-7.621-33.702-1.245-40.539c6.666-7.149,18.451,9.747,24.708,26.488 c6.257,16.741,3.583,32.764,5.338,46.667c0.367,2.727,0.744,13.084,1.098,27.451c1.898-15.458,5.679-25.814,12.686-35.464 c8.618-11.869,16.058-26.323,23.159-24.455c7.101,1.868,3.279,20.993-2.339,34.419c-5.003,11.957-29.683,23.883-33.32,33.496 c0.428,19.474,0.811,44.145,1.082,67.115c1.946-11.865,0.608-12.861,8.581-31.026c4.74-10.799,24.173-24.117,26.491-16.697 c2.274,7.282-1.205,21.443-8.541,31.265c-5.918,7.923-19.049,7.914-22.088,12.83c-0.709,1.147-3.053,5.544-4.392,8.072 c0.317,28.043,0.459,52.797,0.302,61.237l-1.274,0.085c0.061-2.179-0.093-16.445-0.343-35.323 c-3.188-10.045-24.654-15.909-31.285-26.355C55.428,297.167,50.441,284.41,53.417,275.867z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M73.601,382.398h41.2c2.251,0,4.191-1.586,4.638-3.792l2.925-14.419H66.038l2.925,14.419 C69.41,380.813,71.35,382.398,73.601,382.398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M64.86,369.777h58.682c1.406,0,2.588-1.056,2.745-2.454l1.2-10.66 c0.184-1.638-1.097-3.072-2.745-3.072H63.66c-1.648,0-2.93,1.434-2.745,3.072l1.2,10.66 C62.272,368.721,63.454,369.777,64.86,369.777z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 142.633,
    y: 317.619,
    style: {
      fill: "#E0E0E0"
    },
    width: 35.207,
    height: 64.78
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E6E6"
    },
    points: "267.579,382.398 149.685,382.398 137.301,294.501 255.195,294.501  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "284.778,382.398 154.37,382.398 141.986,294.501 272.394,294.501  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "167.135,368.658 156.703,308.241 259.629,308.241 270.061,368.658  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFA"
    },
    points: "211.36,368.658 176.375,308.241 187.351,308.241 222.336,368.658  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFA"
    },
    points: "226.988,368.658 192.003,308.241 210.719,308.241 245.704,368.658  "
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M407.263,297.873c6.687-41.196-43.192-154.321-91.331-191.243 c-62.434-47.885-143.91-28.964-180.405,55.085c-33.906,78.086,3.514,158.18,71.333,185.118 C267.251,370.821,401.26,347.859,407.263,297.873z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M407.263,297.873c6.687-41.196-43.192-154.321-91.331-191.243 c-62.434-47.885-143.91-28.964-180.405,55.085c-33.906,78.086,3.514,158.18,71.333,185.118 C267.251,370.821,401.26,347.859,407.263,297.873z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow_1_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__280_",
    style: {
      fill: "#F5F5F5"
    },
    cx: 250,
    cy: 416.238,
    rx: 193.889,
    ry: 11.323
  })), /*#__PURE__*/React.createElement("g", {
    id: "Warning"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M77.266,221.53c-0.22,0-0.405-0.168-0.424-0.391l-2.222-26.702 c-0.02-0.234,0.154-0.439,0.389-0.459c0.22-0.017,0.439,0.154,0.459,0.389l2.222,26.702c0.02,0.234-0.154,0.439-0.389,0.459 C77.289,221.529,77.278,221.53,77.266,221.53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M78.585,237.39c-0.22,0-0.405-0.168-0.424-0.391l-0.673-8.083 c-0.02-0.234,0.154-0.439,0.389-0.459c0.225-0.029,0.44,0.153,0.459,0.389l0.673,8.083c0.02,0.234-0.154,0.439-0.389,0.459 C78.609,237.389,78.597,237.39,78.585,237.39z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M303.555,313.371H97.081c-5.268,0-9.937-4.31-10.376-9.579L75.077,164.019 c-0.438-5.268,3.513-9.579,8.782-9.579h206.474c5.268,0,9.937,4.31,10.376,9.579l11.629,139.773 C312.776,309.06,308.824,313.371,303.555,313.371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M303.555,313.77H97.081c-5.484,0-10.317-4.461-10.773-9.944L74.68,164.053 c-0.223-2.667,0.618-5.182,2.365-7.081c1.739-1.89,4.159-2.931,6.814-2.931h206.475c5.483,0,10.316,4.462,10.772,9.945 l11.629,139.772c0.223,2.667-0.618,5.181-2.365,7.079C308.63,312.728,306.21,313.77,303.555,313.77z M83.859,154.84 c-2.429,0-4.64,0.949-6.226,2.673c-1.595,1.732-2.361,4.031-2.158,6.474l11.628,139.772c0.423,5.08,4.899,9.212,9.979,9.212 h206.474c2.43,0,4.641-0.949,6.228-2.673c1.594-1.733,2.36-4.031,2.157-6.473l-11.629-139.772 c-0.423-5.08-4.898-9.213-9.977-9.213H83.859z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M290.333,154.441H83.859c-5.268,0-9.22,4.31-8.782,9.579h225.631 C300.27,158.751,295.601,154.441,290.333,154.441z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M88.692,159.23c0.095,1.141-0.753,2.066-1.894,2.066c-1.141,0-2.143-0.925-2.238-2.066 c-0.095-1.141,0.753-2.066,1.894-2.066C87.595,157.164,88.597,158.089,88.692,159.23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M97.092,159.23c0.095,1.141-0.753,2.066-1.894,2.066s-2.142-0.925-2.237-2.066 c-0.095-1.141,0.753-2.066,1.894-2.066S96.997,158.089,97.092,159.23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M105.492,159.23c0.095,1.141-0.753,2.066-1.894,2.066s-2.143-0.925-2.237-2.066 c-0.095-1.141,0.753-2.066,1.894-2.066S105.397,158.089,105.492,159.23z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M285.637,295.054H111.952c-4.188,0-7.899-3.426-8.248-7.614l-8.111-97.489 c-0.348-4.188,2.793-7.614,6.981-7.614h173.684c4.188,0,7.899,3.426,8.248,7.614l8.111,97.489 C292.966,291.628,289.825,295.054,285.637,295.054z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#263238"
    },
    d: "M231.923,199.407l-53.808,64.783c-7.381,8.887-2.705,22.434,8.586,24.876 l87.273,18.875c12.052,2.607,22.123-9.31,17.543-20.759l-33.465-83.658C253.719,192.691,239.378,190.432,231.923,199.407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#263238"
    },
    d: "M112.161,208.49L93.42,258.956c-2.501,6.734,2.914,13.762,10.063,13.061l54.729-5.367 c7.674-0.753,11.46-9.712,6.651-15.74l-35.987-45.1C124.158,199.899,114.794,201.4,112.161,208.49z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M250.484,183.096l-50.301,73.037c-6.852,9.949-0.782,23.625,11.192,25.218l92.465,12.306 c12.834,1.708,22.377-11.6,16.642-23.208l-42.164-85.343C272.848,174.034,257.49,172.924,250.484,183.096z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M213.57,274.804c-3.363-0.447-6.286-2.568-7.819-5.671c-1.533-3.104-1.357-6.542,0.472-9.199 l50.428-73.221c1.829-2.655,4.929-3.974,8.291-3.527c3.363,0.448,6.286,2.568,7.819,5.671l42.27,85.558 c1.534,3.104,1.357,6.542-0.473,9.199c-1.829,2.655-4.929,3.974-8.291,3.527L213.57,274.804z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M260.648,209.069l5.889,0.784c3.787,0.504,6.702,3.949,6.509,7.694l-0.395,7.682 c-0.014,0.282-0.047,0.561-0.096,0.835l-4.19,23.15c-0.604,3.336-3.652,5.494-7.11,5.034l0,0 c-3.466-0.461-6.255-3.407-6.501-6.865l-1.699-23.924c-0.02-0.277-0.022-0.554-0.008-0.829l0.395-7.691 C253.635,211.193,256.861,208.565,260.648,209.069z M260.178,260.629l1.606,0.214c3.388,0.451,5.994,3.532,5.822,6.882v0 c-0.172,3.35-3.058,5.7-6.446,5.25l-1.606-0.214c-3.388-0.451-5.994-3.532-5.822-6.882l0,0 C253.905,262.529,256.791,260.178,260.178,260.629z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M131.505,194.26l-13.811,52.374c-1.829,6.935,4.224,13.395,11.263,12.021l53.572-10.453 c7.528-1.469,10.47-10.668,5.192-16.233l-39.76-41.921C142.719,184.522,133.447,186.895,131.505,194.26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M128.855,254.413c-1.948,0.38-3.975-0.303-5.42-1.827c-1.446-1.525-2.01-3.572-1.507-5.477 l13.846-52.506c0.502-1.904,1.965-3.268,3.914-3.648c1.948-0.38,3.975,0.303,5.42,1.827l39.861,42.027 c1.446,1.525,2.01,3.572,1.507,5.477c-0.502,1.904-1.965,3.268-3.913,3.648L128.855,254.413z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M142.285,206.93l3.412-0.666c2.194-0.428,4.471,1.033,5.084,3.262l1.259,4.573 c0.046,0.168,0.082,0.337,0.107,0.507l2.131,14.356c0.307,2.069-0.966,3.914-2.969,4.305l0,0 c-2.008,0.392-4.119-0.801-4.92-2.778l-5.542-13.685c-0.064-0.159-0.119-0.32-0.164-0.484l-1.26-4.579 C138.81,209.513,140.091,207.358,142.285,206.93z M151.94,237.212l0.931-0.182c1.963-0.383,3.999,0.924,4.548,2.918l0,0 c0.549,1.995-0.597,3.922-2.56,4.305l-0.93,0.182c-1.963,0.383-3.999-0.924-4.548-2.918l0,0 C148.831,239.522,149.977,237.595,151.94,237.212z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F3E3B"
    },
    d: "M388.363,206.035l-7.761,2.521l6.243,7.387c0,0,2.94-2.504,4.544-5.312 c0.67-1.173,0.283-2.666-0.883-3.346L388.363,206.035z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7F3E3B"
    },
    points: "377.03,214.618 381.684,220.271 386.845,215.943 380.602,208.556  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.2
    },
    x1: 420.715,
    y1: 139.01,
    x2: 420.715,
    y2: 139.01
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F3E3B"
    },
    d: "M390.866,145.678c1.897,5.198,3.636,10.397,5.283,15.67c1.626,5.285,3.176,10.561,4.497,16.106 l0.473,2.126l0.22,1.111l0.109,0.555l0.027,0.14l0.031,0.212l0.059,0.425c0.279,2.264,0.042,4.044-0.271,5.694 c-0.653,3.267-1.714,6.038-2.882,8.728c-2.377,5.342-5.227,10.143-8.563,14.797l-5.186-2.868 c1.837-4.983,3.651-10.115,5.011-15.058c0.654-2.462,1.216-4.946,1.383-7.095c0.075-1.051,0.023-2.034-0.121-2.478l-0.43-1.564 l-0.557-1.846c-1.569-5.008-3.359-10.156-5.13-15.271c-1.761-5.124-3.538-10.287-5.243-15.421L390.866,145.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M347.677,114.743c0.132,0.623-0.088,1.211-0.491,1.313c-0.404,0.102-0.838-0.321-0.97-0.944 c-0.132-0.623,0.088-1.211,0.492-1.313S347.545,114.119,347.677,114.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#630F0F"
    },
    d: "M347.646,115.939c0,0-0.642,3.95-1.819,6.075c1.31,0.753,3.067-0.186,3.067-0.186L347.646,115.939z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M346.027,110.959c-0.118,0-0.234-0.056-0.307-0.159c-0.118-0.169-0.077-0.402,0.092-0.521 c0.061-0.042,1.503-1.029,3.386-0.254c0.191,0.079,0.282,0.297,0.204,0.488c-0.079,0.191-0.297,0.283-0.488,0.203 c-1.509-0.622-2.661,0.168-2.672,0.176C346.176,110.937,346.101,110.959,346.027,110.959z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F3E3B"
    },
    d: "M369.112,116.724c0.697,7.259-0.332,14.288,1.293,20.599c0,0-1.805,5.857-12.534,5.857 c-11.798,0-5.412-5.857-5.412-5.857c6.499-1.538,6.517-6.315,5.568-10.802L369.112,116.724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M372.691,139.334c0.917-1.854,1.526-4.479-0.375-5.144c-2.091-0.731-13.256-0.974-17.308,0.398 c-4.052,1.373-3.063,5.133-3.063,5.133L372.691,139.334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M396.799,402.693c0.776-0.184,1.575-0.543,2.125-0.821c0.073-0.037,0.117-0.115,0.111-0.197 c-0.006-0.082-0.06-0.153-0.138-0.179c-0.351-0.119-3.452-1.142-4.267-0.445c-0.126,0.108-0.265,0.307-0.208,0.643 c0.077,0.451,0.299,0.772,0.66,0.953C395.537,402.876,396.16,402.844,396.799,402.693z M398.281,401.729 c-1.357,0.623-2.466,0.83-3.016,0.553c-0.241-0.121-0.385-0.337-0.44-0.657c-0.027-0.157,0.024-0.223,0.07-0.263 C395.319,401,397.031,401.353,398.281,401.729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M398.879,401.889c0.038-0.009,0.073-0.029,0.101-0.058c0.052-0.054,0.07-0.132,0.047-0.203 c-0.032-0.101-0.806-2.475-1.969-3.041c-0.303-0.147-0.608-0.166-0.907-0.055h0c-0.461,0.171-0.517,0.493-0.509,0.671 c0.044,0.978,2.158,2.419,3.138,2.685C398.812,401.896,398.846,401.896,398.879,401.889z M396.38,398.887 c0.164-0.039,0.327-0.017,0.498,0.066c0.746,0.363,1.348,1.711,1.613,2.395c-1.018-0.451-2.416-1.587-2.442-2.165 c-0.002-0.053-0.008-0.176,0.243-0.269l0,0C396.321,398.903,396.351,398.894,396.38,398.887z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M342.175,408.795c0.798,0,1.658-0.165,2.257-0.31c0.08-0.019,0.141-0.085,0.154-0.166 c0.013-0.081-0.024-0.162-0.093-0.206c-0.314-0.197-3.096-1.905-4.05-1.415c-0.148,0.076-0.329,0.238-0.35,0.578 c-0.029,0.457,0.113,0.82,0.422,1.08C340.905,408.683,341.519,408.795,342.175,408.795z M343.84,408.198 c-1.464,0.294-2.59,0.24-3.062-0.156c-0.207-0.174-0.298-0.416-0.277-0.741c0.01-0.159,0.074-0.212,0.129-0.24 C341.125,406.807,342.709,407.544,343.84,408.198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M344.384,408.491c0.039,0,0.078-0.011,0.111-0.033c0.063-0.041,0.098-0.113,0.092-0.187 c-0.008-0.106-0.214-2.594-1.216-3.413c-0.261-0.213-0.554-0.302-0.87-0.263h0c-0.488,0.06-0.617,0.361-0.65,0.535 c-0.182,0.961,1.543,2.851,2.435,3.335C344.317,408.483,344.351,408.491,344.384,408.491z M342.643,404.995 c0.168,0,0.322,0.059,0.469,0.179c0.642,0.525,0.918,1.975,1.018,2.702c-0.887-0.674-1.986-2.101-1.879-2.669 c0.01-0.052,0.033-0.173,0.298-0.206l0,0C342.582,404.997,342.613,404.995,342.643,404.995z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7F3E3B"
    },
    points: "353.667,408.179 345.774,408.179 345.694,389.9 353.587,389.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7F3E3B"
    },
    points: "408.663,401.416 401.064,402.809 395.613,384.822 403.212,383.429  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M399.618,400.787l8.629-2.041c0.314-0.074,0.629,0.082,0.758,0.375l2.868,6.531 c0.297,0.678-0.127,1.485-0.854,1.644c-3.023,0.66-4.522,0.828-8.316,1.725c-2.335,0.552-7.097,1.934-10.321,2.697 c-3.153,0.746-4.276-2.355-3.013-2.959c5.662-2.706,7.538-5.035,9.096-7.202C398.745,401.167,399.159,400.895,399.618,400.787z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M345.862,407.265l8.62,0c0.323,0,0.593,0.224,0.651,0.539l1.288,7.016 c0.133,0.727-0.445,1.417-1.19,1.404c-3.107-0.053-7.593-0.235-11.502-0.235c-4.57,0-6.198,0.249-11.557,0.249 c-3.24,0-4.013-3.276-2.645-3.573c6.227-1.351,8.946-1.496,14.409-4.786C344.53,407.522,345.18,407.265,345.862,407.265z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M388,139.361c7.366,5.184,9.585,18.545,9.585,18.545l-16.696,8.465c0,0-4.24-8.218-6.097-16.57 C373.034,141.897,382.764,135.676,388,139.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M379.65,147.882l6.579,15.762l-5.336,2.729c0,0-2.328-4.532-4.32-10.325L379.65,147.882z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M338.89,174.033c0.057,8.81,0.59,19.769,1.903,33.371h42.225 c0.517-6.201-2.073-35.437,4.212-64.707c0.467-2.177-0.989-4.297-3.189-4.639c-2.691-0.418-6.371-0.898-9.972-1.072 c-5.384-0.258-13.188-0.43-17.943,0c-2.586,0.235-5.117,0.648-7.199,1.053c-3.603,0.701-6.468,3.392-7.421,6.936 c-0.911,3.388-1.842,8.596-2.311,16.454C338.979,165.051,338.861,169.219,338.89,174.033z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M352.214,157.46c-2.79,2.05-8.13,2.99-12.99,3.41c0.08-1.29,0.18-2.51,0.29-3.66 c1.309-0.69,2.57-1.32,3.76-1.9L352.214,157.46z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "345.695,389.905 345.735,400.063 353.632,400.063 353.592,389.905  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "403.215,383.434 395.613,384.827 398.426,394.098 406.029,392.704  "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F3E3B"
    },
    d: "M367.986,108.222c1.156,7.772,2.223,12.248-0.773,17.144c-4.507,7.364-14.607,6.222-18.035-0.962 c-3.085-6.466-4.458-18.09,2.317-23.011C358.169,96.545,366.829,100.45,367.986,108.222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M351.838,113.896c-2.925-1.285-2.647-5.896-1.758-7.84c-3.389,1.167-8.289,1.833-9.172-1.611 c-0.883-3.444,2.117-4.555,0.283-7.5c-1.833-2.944,4-6.167,6.722-2.055s9.436,2.304,13.778-1.667 c3.158-2.889,7.778,0.833,5.944,4.611c0,0,9.5-0.611,7.611,5.833c-1.889,6.444-4.556,6.677-3.945,11.26 c0.414,3.103,0.778,9.406-2.944,10.295C363.861,126.296,352.635,122.312,351.838,113.896z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M351.784,122.31c-0.86,0.62-1.75,1.28-2.66,1.98c0.02,0.04,0.03,0.07,0.05,0.11 c0.94,1.97,2.39,3.49,4.09,4.51c0.565-0.549,0.881-2.396,1.947-2.368c3.167,0.083,9.301-1.241,10.316-4.818L351.784,122.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F3E3B"
    },
    d: "M354.246,113.786c0.221,1.993-0.149,3.86-0.751,5.076c-0.906,1.829-2.322,0.663-2.877-1.587 c-0.499-2.026-0.63-5.419,0.668-6.416C352.563,109.875,353.993,111.507,354.246,113.786z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M355.771,207.404c0,0,6.629,60.32,10.674,82.919c4.43,24.747,27.37,102.425,27.37,102.425 l14.14-3.011c0,0-15.79-72.669-17.917-97.17c-2.308-26.592-7.025-85.162-7.025-85.162H355.771z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M355.771,207.404c0,0,6.629,60.32,10.674,82.919c4.43,24.747,27.37,102.425,27.37,102.425 l14.14-3.011c0,0-15.79-72.669-17.917-97.17c-2.194-25.28-2.198-25.227-7.025-85.162H355.771z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M390.648,387.976c-0.06,0.013,2.406,5.163,2.406,5.163l15.909-3.388l-1.137-4.823L390.648,387.976z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M360.602,228.896c10.279,2.031,7.692,40.656,5.678,60.522c-2.445-14.043-5.774-41.064-8.021-60.243 C358.961,228.832,359.739,228.724,360.602,228.896z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M340.795,207.404c0,0-3.365,59.015-3.436,83.085c-0.074,25.036,5.506,107.013,5.506,107.013 h13.371c0,0,3.599-80.514,5.144-105.102c1.684-26.806,7.167-84.996,7.167-84.996H340.795z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M340.795,207.404c0,0-3.365,59.015-3.436,83.085c-0.074,25.036,5.506,107.013,5.506,107.013h13.371 c0,0,3.599-80.514,5.144-105.102c1.684-26.806,7.167-84.996,7.167-84.996H340.795z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M340.497,392.176c-0.062,0,0.54,5.551,0.54,5.551h16.265l0.631-4.954L340.497,392.176z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F3E3B"
    },
    d: "M357.519,151.739c-1.596,0.156-2.951,0.237-4.415,0.28c-1.437,0.047-2.871,0.066-4.308,0.061 c-2.872-0.032-5.755-0.177-8.652-0.502c-2.898-0.311-5.812-0.78-8.744-1.501c-2.933-0.705-5.887-1.687-8.822-3.131l-0.333-0.164 c-2.585-1.272-3.65-4.399-2.378-6.984c0.138-0.281,0.317-0.567,0.496-0.811c1.366-1.836,2.691-3.116,4.046-4.327 c1.35-1.195,2.701-2.27,4.062-3.292c2.716-2.051,5.498-3.862,8.289-5.622c2.806-1.736,5.638-3.384,8.509-4.952 c2.894-1.544,5.757-3.061,8.759-4.455c1.492-0.693,3.263-0.045,3.956,1.447c0.599,1.29,0.196,2.789-0.889,3.619l-0.034,0.025 c-2.515,1.926-5.102,3.841-7.61,5.801c-2.527,1.942-5.041,3.885-7.495,5.866c-2.464,1.961-4.862,3.983-7.127,6.014 c-1.132,1.016-2.215,2.052-3.189,3.085c-0.96,1.021-1.872,2.08-2.358,2.883l-2.216-7.959c2.036,0.792,4.334,1.36,6.723,1.792 c2.396,0.415,4.886,0.686,7.411,0.862c2.527,0.16,5.091,0.244,7.663,0.245c1.286,0.008,2.575-0.006,3.86-0.044 c1.258-0.047,2.623-0.092,3.741-0.154l0.137-0.008c3.298-0.185,6.122,2.338,6.308,5.636 C363.091,148.662,360.69,151.425,357.519,151.739z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F3E3B"
    },
    d: "M363.118,114.722l-5.022,1.109c0,0-6.689-0.831-8.22,4.211l3.963,3.383l6.118,0.967 c0.97,0.153,1.964-0.008,2.836-0.46l1.562-0.81c0.718-0.372,1.197-1.084,1.272-1.889l0.37-3.969 C366.146,115.66,364.691,114.375,363.118,114.722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M353.358,157.583c-8.411,2.333-18-0.583-18-0.583l3.528-18.833c0,0,8.356-0.732,13.573-0.843 C365.888,137.04,368.521,153.377,353.358,157.583z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnauthorizedImg);
export default __webpack_public_path__ + "static/media/unauthorized_img.7c243a03c19bd90da1515ef3d4c5851b.svg";
export { ForwardRef as ReactComponent };